module.exports = __webpack_public_path__ + "static/media/bottom.b04848ab.jpg";